import { useCallback, useEffect, useState } from "react";
import { MotionConfig } from "framer-motion";
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastProvider } from "./context/ToastContext";
import { IntroProvider } from "./context/IntroContext";
import Loader from "./components/loader/Loader";
import Nav from "./components/nav/Nav";
import Footer from "./components/footer/Footer";
import CommandPalette from "./components/command/CommandPalette";
import ScrollProgress from "./components/ui/ScrollProgress";
import ScrollManager from "./components/ui/ScrollManager";
import Home from "./pages/Home";
import ProjectPage from "./pages/ProjectPage";

const isTypingTarget = (el) =>
  el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);

const Layout = () => {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const openPalette = useCallback(() => setPaletteOpen(true), []);
  const closePalette = useCallback(() => setPaletteOpen(false), []);

  useEffect(() => {
    const onKey = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setPaletteOpen((open) => !open);
      } else if (event.key === "/" && !isTypingTarget(document.activeElement)) {
        event.preventDefault();
        setPaletteOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <ScrollManager />
      <ScrollProgress />
      <Nav onOpenPalette={openPalette} />
      <main id="main">
        <Outlet context={{ openPalette }} />
      </main>
      <Footer />
      <CommandPalette open={paletteOpen} onClose={closePalette} />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <IntroProvider>
          <MotionConfig reducedMotion="user">
            <Loader />
            <Router>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/work/:id" element={<ProjectPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </Router>
          </MotionConfig>
        </IntroProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
